import { gql, useMutation } from "@apollo/client";

const TEST_MUTATION = gql`
  mutation TestMutation($value: String) {
    testMutation(value: $value)
  }
`;

export const useTestMutation = () => {
  const [testMutation, { loading, error, data }] = useMutation(TEST_MUTATION);

  return { testMutation, loading, error, data };
};
